import { TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRegTimesCircle, FaTimes } from "react-icons/fa";
import { HiOutlineSearch } from "react-icons/hi";
import { openSnackBar } from '../../../redux/snackBarReducer';
import NewProducer from "../NewProducer";
import { useDispatch, useSelector } from 'react-redux'
import { Button } from "flowbite-react";
import {parse as tab_parse, stringify as tab_stringify} from 'tab-delimited';
import FileSaver from 'file-saver';
import {Buffer} from 'buffer/'
import { downloadProducerImage } from "../../../redux/producerReducer";
import { API_BASE } from "../../../config/constants"

import './producertabletoolbar.scss';

function ProducerTableToolbar(props) {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { authState, producerState } = useSelector((state) => state);
    const { userInfo } = authState;

    useEffect(() => {
    }, [])

    const [search, setSearch] = useState("");   //search bar text 
    const [filterArray, setFilterArray] = useState([]);

    const changeSearch = (e) => {
        setSearch(e.target.value);
    }

    const keyDownSearch = (e) => {
        var flag = false;
        if (e.keyCode === 13) {
            if (search.trim()) {
                if (filterArray.length > 0) {
                    filterArray.map(data => {
                        if (data.type === "text" && data.value === search.trim()) {
                            flag = true;
                        } else {
                            flag = false;
                        }
                    })
                }
                if (!flag) {
                    setFilterArray([...filterArray, { type: "text", value: search.trim() }]);
                    setSearch("");

                    const { setCondition, getData } = props;
                    setCondition("filterArray", [...filterArray, { type: "text", value: search.trim() }]);
                    setCondition("currentPage", 0);
                    getData();
                } else {
                    dispatch(openSnackBar({ status: "error", message: t("msg_filter_name_exist") }));
                }
            }
        }
    }

    const removeSelectedFilter = (index) => {
        filterArray.splice(index, 1);
        setFilterArray([...filterArray]);

        const { setCondition, getData } = props;
        setCondition("filterArray", [...filterArray]);
        setCondition("currentPage", 0);
        getData();
    }

    const removeAllFilter = () => {
        setFilterArray([]);

        const { setCondition, getData } = props;
        setCondition("filterArray", []);
        setCondition("currentPage", 0);
        getData();
    }

    const exportCSV = async () => {
        let producer_data = producerState.total_producers
        if(producer_data && producer_data.length > 0){
            let datas = [[
                'product_id', 'producer_name', "image_logo", "image_producer1", "image_producer2", 
                "country_en", "country_de", "country_fr", "country_sk", "country_it", "country_es", "country_pt", "country_nl", "country_native",
                "region_en", "region_de", "region_fr", "region_sk", "region_it", "region_es", "region_pt", "region_nl", "region_native", "description"
            ]];

            producer_data.map((data, index) => {
                const { _id, logo, producer_image1, producer_image2, name, country, region, description } = data;
                
                datas = [...datas, {
                    product_id: _id, 
                    producer_name: name,
                    image_logo: logo.changed_name ? "/image/" + logo.changed_name.toString() : "   ",
                    image_producer1: producer_image1.changed_name ? "/image/" + producer_image1.changed_name.toString() : "   ",
                    image_producer2: producer_image2.changed_name ? "/image/" + producer_image2.changed_name.toString() : "   ",
                    country_en: country.name.en,
                    country_de: country.name.de,
                    country_fr: country.name.fr,
                    country_sk: country.name.sk,
                    country_it: country.name.it,
                    country_es: country.name.es,
                    country_pt: country.name.pt,
                    country_nl: country.name.nl,
                    country_native: country.name.native,
                    region_en: region.name.en,
                    region_de: region.name.de,
                    region_fr: region.name.fr,
                    region_sk: region.name.sk,
                    region_it: region.name.it,
                    region_es: region.name.es,
                    region_pt: region.name.pt,
                    region_nl: region.name.nl,
                    region_native: region.name.native,
                    description: description
                }]
            })

            let tabdata = tab_stringify(datas);
            // tabdata = tabdata.replace('image_path', '@images')
            tabdata = tabdata.replace(/undefined	/g, '         	')
            // console.log(tabdata);

            const buffer = Buffer.from(tabdata, 'utf16le')

            // download txt 
            var blob = new Blob([buffer]);
            FileSaver.saveAs(blob, 'producer');
            
            // download image
            let res = await dispatch(downloadProducerImage())
            if(res != false){
                downloadImageFile(res.name, "producer");
            }else{
                dispatch(openSnackBar({ message: t("image download failed"), status: 'error' }));
            }
        }
    }

    const downloadImageFile = (name, producer_name) => {
		fetch( `${API_BASE}/public/download/`+name)
			.then(response => {
				response.blob().then(blob => {
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = producer_name + "-" + name;
					a.click();
				});
				//window.location.href = response.url;
		});
	}

    return (
        <div>
            {/* <div className="flex pt-6 pb-2.5 px-4">
                <div className="px-2 flex-system-flex-end flex-wrap">
                    <TextInput
                        style={{width:'150px'}}
                        id="searchProducer"
                        type="search"
                        sizing="md"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                </div>
                <div className="px-2">
                    <NewProducer condition={props.condition} />
                </div>
            </div> */}
            <div className="producttabletoolbar-layout">
                <div className="header">{t("producers")}</div>
                <div className="actions">
                    <div>{
                        userInfo?.role === 0 &&
                        <div>
                            <Button onClick={() => exportCSV()} color="red" outline={true} className=" border-2 border-gray-200 bg-white mr-2" >
                                {/* <BiExport className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                                <svg className="h-5  w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 14.25V20.25" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 20.25L15 18" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 20.25L19.5 18" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M10.226 4.557C10.2602 4.83153 10.2356 5.11018 10.1539 5.37449C10.0722 5.63879 9.9352 5.88269 9.75202 6.09C9.56106 6.2974 9.32917 6.46294 9.07099 6.57617C8.8128 6.68941 8.53395 6.74787 8.25202 6.74787C7.9701 6.74787 7.69124 6.68941 7.43306 6.57617C7.17488 6.46294 6.94299 6.2974 6.75202 6.09C6.56884 5.88269 6.43185 5.63879 6.35013 5.37449C6.26841 5.11018 6.24383 4.83153 6.27802 4.557L6.75002 0.75H9.75002L10.226 4.557Z" /><path stroke="#000000" d="M8.25 13.875C8.04289 13.875 7.875 13.7071 7.875 13.5C7.875 13.2929 8.04289 13.125 8.25 13.125" /><path stroke="#000000" d="M8.25 13.875C8.45711 13.875 8.625 13.7071 8.625 13.5C8.625 13.2929 8.45711 13.125 8.25 13.125" /><path stroke="#000000" d="M8.25 17.625C8.04289 17.625 7.875 17.4571 7.875 17.25C7.875 17.0429 8.04289 16.875 8.25 16.875" /><path stroke="#000000" d="M8.25 17.625C8.45711 17.625 8.625 17.4571 8.625 17.25C8.625 17.0429 8.45711 16.875 8.25 16.875" /><g><path stroke="#000000" d="M8.25 10.125C8.04289 10.125 7.875 9.95711 7.875 9.75C7.875 9.54289 8.04289 9.375 8.25 9.375" /><path stroke="#000000" d="M8.25 10.125C8.45711 10.125 8.625 9.95711 8.625 9.75C8.625 9.54289 8.45711 9.375 8.25 9.375" /></g><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M7.5 20.25H2.25C1.85218 20.25 1.47064 20.092 1.18934 19.8107C0.908035 19.5294 0.75 19.1478 0.75 18.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.879C13.2765 0.750085 13.6578 0.907982 13.939 1.189L16.811 4.061C17.092 4.3422 17.2499 4.72345 17.25 5.121V8.25" /></svg>
                                {t("export_csv")}
                            </Button>
                        </div>
                    }</div>

                    <TextInput className="item tool-search"
                        id="searchProduct"
                        type="search"
                        sizing="md"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                 
                    <div className="px-2 item">
                        <NewProducer condition={props.condition}/>
                    </div>
                </div>
            </div>
            <div className="filter">
                {
                    filterArray?.length > 0 &&
                    <div className="flex pl-4 cursor-pointer" onClick={() => removeAllFilter()}>
                        <div className="inline-flex items-center text-sm font-medium text-slate-100 bg-red-100 rounded-full text-center px-4 py-2">
                            <span className="text-xs text-sitebg-50">{t("remove_all_tag")}</span>
                            <FaRegTimesCircle onClick={() => removeAllFilter()} className="ml-2 h-4 w-4 text-sitebg-50 " />
                        </div>
                    </div>
                }
                {
                    filterArray.map((data, i) =>
                        <div key={i} className="tag item">
                            <p className="tag-text mr-2" >{data.type !== "text" && `${data.type}:`}
                                <b className="text-xs"> "{data.value}"</b>
                            </p>
                            <FaTimes onClick={() => removeSelectedFilter(i)} className="cursor-pointer" />
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default ProducerTableToolbar;
